import { AlertMessage } from '@/ui-kit';
import type { FormAlertMessage } from '../../typings';
import type { FC } from 'react';

type FormFieldAlertMessageProps = {
  alertMessage: FormAlertMessage;
};

export const FormFieldAlertMessage: FC<FormFieldAlertMessageProps> = ({
  alertMessage,
}) => (
  <AlertMessage
    className="alert-message-full-width"
    variant={alertMessage.variant}
    description={alertMessage.value}
  />
);
